<template>
  <div
    class="build-version"
    :title="title"
  >
    Environment: {{ env }} | {{ title }}
  </div>
</template>
<script setup>
import { computed, onMounted, ref } from 'vue';

const version = ref();
const env = process.env.ENV;

const fetchVersion = () => {
  fetch('/version.json').then(async (res) => {
    const json = await res.json();
    version.value = json.version;
  }).catch(() => {});
};

onMounted(() => {
  fetchVersion();
});

const title = computed(() => {
  let timeStr = new Date().toString();
  if (version.value) {
    timeStr = new Date(version.value).toString();

    return `Build time: ${timeStr}`;
  }

  return 'Version not found';
});
</script>
<style scoped>
.build-version {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 100000;
  background-color: #dee9ff;
  color: #9f9f9f;
  font-size: 8px;
  border-radius: 2px;
  padding: 0 2px;
}
</style>
